module.exports = __webpack_public_path__ + "static/img/pk-miss.79d70fb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/matchInfo/pk-miss.svg
// module id = Mjwm
// module chunks = 1